import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$organizationName/settings/machines/$machineId/')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/settings/machines/$machineId/$tab',
      params: { ...params, tab: 'overview' },
    });
  },
});
